import React from 'react';
import InventoryAddEditModal from './inventory-add-edit';
 
import { MODAL_TYPES } from 'Feature/components/app-modals';

const { INVENTORY_ADD_EDIT } = MODAL_TYPES;

const InventoryModals = () => {
  return (
    <>
      <InventoryAddEditModal modalId={INVENTORY_ADD_EDIT} />
      
    </>
  );
};

export default InventoryModals;
